// extracted by css-extract-rspack-plugin
export default {"list-wrapper":"sPVCSd","listWrapper":"sPVCSd","list":"KnLiGJ","item":"xtEWcA"};